import { render, staticRenderFns } from "./ShareStorage.vue?vue&type=template&id=24db69ee"
import script from "./ShareStorage.vue?vue&type=script&lang=js"
export * from "./ShareStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports